<template>
  <div class="container_a">
    <PublicTable :table="tableData" ref="PublicTable">
      <template v-for="(item,index) in tableData.config" :slot="item.value" slot-scope="props">
        <div v-if="item.show == 'template'" :key="index">
          <div v-if="item.value == 'examineState'">
            <span v-if="props.scope.row.examineState == 1" style="color:#FFBF00">待审核</span>
            <span v-else-if="props.scope.row.examineState == 2" style="color:#FF6010">被驳回</span>
            <span v-else-if="props.scope.row.examineState == 3" style="color:#269D7B">审核通过</span>
            <span v-else>无需审核</span>
          </div> 
          <div v-else-if="item.value == 'accountingState'">
            <span v-if="props.scope.row.accountingState == 1" style="color:#FFBF00">空结转</span>
            <span v-else-if="props.scope.row.accountingState == 2" style="color:#FF6010">仅工资</span>
            <span v-else-if="props.scope.row.accountingState == 3" style="color:#269D7B">仅工资社保</span>
            <span v-else>有收支</span>
          </div>
          <span v-else>{{ props.scope.row[item.value] }}</span>
        </div>
      </template>
      <template v-for="(item,index) in ['cash','bank','rawMaterials','goodsInStock','deferredExpenses']" :slot="item" slot-scope="props">
        <span v-if="true" :key="index" :style="{color:props.scope.row[item] ? '#FF1010' : '#000000'}">{{ props.scope.row[item] ? '赤字 ' : '无赤字 ' }}</span>
      </template>
      <template v-slot:voucherDiscontinuousNumber="{scope}">
        <div style="cursor:pointer" @click="$router.push({path:'/queryVoucher',query: {date: scope.row.yearPeriods}})">
          <span v-if="scope.row.voucherDiscontinuousNumber" style="color:#FF1010">有断号</span>
          <span v-else style="color:#268AFF">无断号</span>
        </div>
      </template>
      <template v-slot:fixedAssets="{scope}">
        <div>
          <span v-if="scope.row.fixedAssets" style="color:#FF1010">固定资产-累计折旧&lt;0</span>
          <span v-else style="color:#000000">固定资产-累计折旧≥0</span>
        </div>
      </template>
      <template  v-slot:assetsLiabilities="{scope}">
        <span 
          style="cursor:pointer;" 
          @click="$router.push({path:'/balanceSheet',query: {date: scope.row.yearPeriods}})"
          :style="{color:!scope.row.assetsLiabilities.includes('平衡') ? '#FF1010' : '#268AFF'}">
          {{ scope.row.assetsLiabilities }}
        </span>
      </template>
      <template v-slot:netProfit="{scope}">
        <span 
          style="cursor:pointer;" 
          @click="$router.push({path:'/profitStatement',query: {date: scope.row.yearPeriods}})"
          :style="{color:!scope.row.netProfit.includes('平衡') ? '#FF1010' : '#268AFF'}">
          {{ scope.row.netProfit }}
        </span>
      </template>
      <template v-slot:problem="{scope}">
        <span style="cursor:pointer;color:#268AFF" @click="lookProblem(scope.row)">查看</span>
      </template>
      <template v-slot:operate="{scope}">
        <span
          :style="{color:judgeOperate(scope.row) ? '#268AFF' : '#a1a1a1',cursor:judgeOperate(scope.row) ? 'pointer' : 'no-drop'}" 
          @click="examineOperate(scope.row,2)"> {{ examineType ? '通过' : '反审核' }} </span>
        <span 
          v-if="examineType"
          style="margin-left:10px" 
          :style="{color:judgeOperate(scope.row)&&examineType ? '#268AFF' : '#a1a1a1',cursor:judgeOperate(scope.row)&&examineType ? 'pointer' : 'no-drop'}" 
          @click="examineOperate(scope.row,1)">驳回</span>
      </template>
    </PublicTable>

    <!-- 查看历史问题 -->
    <HistoryProblem ref="HistoryProblem" />
  </div>
</template>

<script>
import PublicTable from "@/components/publicTable"
import HistoryProblem from './HistoryProblem'
import { findExamineList } from "@/api"
import { examineTab } from "../config/tabConfig"
export default {
  components: { PublicTable,HistoryProblem },
  props: {},
  created() {},
  data() {
    return {
      year: '',
      examineType: 1,
      dialogVisible: false,
      tableData: {
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        hasSelect: true, // 是否显示多选
        hasOperation: false, // 是否有操作功能
        hasContextmenu: false, // 是否有右键功能
        hasShowSummary: false, // 是否显示合计行
        hasShowPagination: false, // 是否显示分页
        config: examineTab,
        data: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          count: 10
        },
        center: {
          textAlign: "center",
          padding: "6px 0"
        },
        toggleRowSelection: this.toggleRowSelection, // 自定义全选方法
        selectable: this.selectable
      }
    }
  },
  methods: {
    handleOpen(type,year) {
      this.year = year
      this.examineType = type
      this.dialogVisible = true
      this.getExamineList()
    },
    // 列表数据
    async getExamineList() {
      // 获取cid
      const cid = JSON.parse(sessionStorage.getItem("cid"))
      try {
        this.tableData.loading = true
        const { data } = await findExamineList({
          cid,year: this.$formart(this.year,'yyyy')
        })
        if (data.code == 1) {
          this.tableData.data = data.data
        }
      } catch (error) {
        this.tableData.loading = false
      }
      this.tableData.loading = false
    },
    // 查看历史问题
    lookProblem(row) {
      console.log(row);
      if(!row.haveProblem) { return this.$message.error('暂无历史问题') }
      this.$refs.HistoryProblem.handleOpen(row)
    },
    // 操作
    examineOperate(row,type) {
      if((!this.judgeOperate(row) || (!this.examineType && this.judgeOperate(row) && type == 1))) return
      if(type == 1 && row.examineState == 2) { return this.$message.error('该数据已经被驳回了哦') }
      this.$emit('examineOperate',row,type)
    },
    toggleRowSelection(list) {
      console.log(list);
      this.$emit('tableSelection',list)
    },
    // 判断按钮状态
    judgeOperate(row) {
      return this.examineType ? row.examineState == 1 : row.examineState == 3
    },
    toggleSelection(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach(row => {
          this.$refs.PublicTable.newToggleRowSelection(row,false);
        });
      } else {
        this.$refs.PublicTable.clearSelection();
      }
    },
    selectable(row, index) {
      return this.judgeOperate(row)
    }
  }
}
</script>

<style lang='less' scoped>
</style>


// WEBPACK FOOTER //
// src/pages/examine/components/ExamineDetail.vue